import { Component } from '@angular/core';
import { SpinnerComponent } from '@group24ag/flowkit';

@Component({
  selector: 'app-ui-spinner',
  imports: [SpinnerComponent],
  template: `
    <div class="flex flex-col gap-4">
      <h1 class="heading-title">Spinner</h1>
      <div class="grid gap-6 md:grid-cols-2">
        <div class="space-y-4">
          <h2 class="text-sm font-medium">Variants</h2>
          <div class="flex items-center gap-6">
            <flk-spinner variant="accent" />
            <flk-spinner variant="info" />
            <flk-spinner variant="default" />
            <flk-spinner variant="magic" />
          </div>
        </div>

        <div class="space-y-4">
          <h2 class="text-sm font-medium">Sizes</h2>
          <div class="flex items-center gap-6">
            <flk-spinner [diameter]="25" />
            <flk-spinner [diameter]="50" />
            <flk-spinner [diameter]="100" />
            <flk-spinner [diameter]="125" />
            <flk-spinner [diameter]="150" />
          </div>
        </div>

        <div class="space-y-4">
          <h2 class="text-sm font-medium">With Background Track</h2>
          <div class="flex items-center gap-6">
            <flk-spinner [diameter]="50" [showTrack]="true" />
            <flk-spinner [diameter]="75" [showTrack]="true" />
          </div>
        </div>
      </div>
    </div>
  `,
})
export class UISpinnerComponent {}
